import { httpClient } from './http';

export type InboxFeedQuery = {
  page?: number;
  limit?: number;
  read?: boolean;
};

export interface InAppNotificationItem {
  id: string;
  type: string;
  title: string;
  body: string;
  payload: Record<string, unknown> | null;
  read: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface InAppFeedResult {
  data: InAppNotificationItem[];
  total: number;
  unreadCount: number;
}

export class NotificationsApi {
  async inboxFeed(query?: InboxFeedQuery): Promise<InAppFeedResult> {
    const qs = new URLSearchParams();
    if (query?.page !== undefined) qs.set('page', String(query.page));
    if (query?.limit !== undefined) qs.set('limit', String(query.limit));
    if (query?.read !== undefined) qs.set('read', String(query.read));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    const res = await httpClient.get<{ success: boolean; data: InAppFeedResult }>(`/api/notifications/inbox/feed${suffix}`);
    return (res as any)?.data ?? { data: [], total: 0, unreadCount: 0 };
  }

  async unreadCount(): Promise<number> {
    const res = await httpClient.get<{ success: boolean; data: { unreadCount: number } }>('/api/notifications/inbox/unread-count');
    return (res as any)?.data?.unreadCount ?? 0;
  }

  async mark(messageId: string, markAs: 'read' | 'unread') {
    return await httpClient.post<any>('/api/notifications/inbox/mark', { messageId, markAs });
  }

  async markAll(markAs: 'read') {
    return await httpClient.post<any>('/api/notifications/inbox/mark-all', { markAs });
  }
}

export const notificationsApi = new NotificationsApi();
